import React from 'react';
import { useSubscriptionImport } from './SubscriptionImportContext';

const SubscriptionStep1File: React.FC = () => {
    const {
        excelData,
        columns,
        descriptionColumn,
        setDescriptionColumn,
        handleFileUpload,
    } = useSubscriptionImport();

    return (
        <div className="file-upload-section">
            <div className="file-input-wrapper">
                <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={handleFileUpload}
                    className="file-input"
                />
            </div>

            {columns.length > 0 && (
                <div className="column-selection">
                    <h3>Spalte für Beschreibung auswählen:</h3>
                    <select
                        value={descriptionColumn}
                        onChange={(e) => setDescriptionColumn(e.target.value)}
                        className="column-select"
                    >
                        {columns.map((col) => (
                            <option key={col} value={col}>
                                {col}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {excelData.length > 0 && (
                <div className="data-preview">
                    <h3>Vorschau der Daten (erste 5 Zeilen):</h3>
                    <div className="preview-scroll">
                        <table className="preview-table">
                            <thead>
                                <tr>
                                    {columns.map((col) => (
                                        <th
                                            key={col}
                                            style={col === descriptionColumn ? { background: '#e7f1ff' } : {}}
                                        >
                                            {col}
                                            {col === descriptionColumn && ' ✓'}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {excelData.slice(0, 5).map((row, idx) => (
                                    <tr key={idx}>
                                        {columns.map((col) => (
                                            <td
                                                key={col}
                                                style={col === descriptionColumn ? { background: '#f0f7ff' } : {}}
                                            >
                                                {String((row as any)[col] ?? '')}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <p className="preview-info">Gesamt: {excelData.length} Zeilen</p>
                </div>
            )}
        </div>
    );
};

export default SubscriptionStep1File;
